import _ from 'underscore';
import { BaseSchemaProcessor } from './base-schema-processor';
import { addCampaignTypePropertyForFilter } from '../util/update-campaign-type-property-for-filter';

export class NegativeKeywordSchemaProcessor extends BaseSchemaProcessor {
  updateEntitySchemaForFeatures(entitySchema) {
    const updatedSchema = entitySchema;

    const campaignNameProperty = updatedSchema.properties.CampaignName;
    campaignNameProperty.title = this.i18n.getString('FilterLocalization_DataAttribute_CampaignName');

    if (updatedSchema.properties.AdGroupName) {
      const adgroupNameProperty = updatedSchema.properties.AdGroupName;
      adgroupNameProperty.title = this.i18n.getString('FilterLocalization_DataAttribute_AdGroupName');
    }

    const textProperty = updatedSchema.properties.Text;
    textProperty.title = this.i18n.getString('FilterLocalization_DataAttribute_NegativeKeyword');

    updatedSchema.properties.MatchType.enum = _.difference(
      updatedSchema.properties.MatchType.enum,
      [
        "Enum.MatchType'Broad'",
        "Enum.MatchType'Content'",
        "Enum.MatchType'Predictive'",
      ]
    );

    if (this.isForVNext) {
      const campaignTypeNotSupported = ["Enum.CampaignType'PerformanceMax'", "Enum.CampaignType'LinkedIn'"];
      addCampaignTypePropertyForFilter({
        entitySchema: updatedSchema, permissions: this.Permissions, property: 'CampaignType', campaignTypeNotSupported,
      });
    }

    return updatedSchema;
  }

  updateOdataOptions(odataOptions) {
    const isExperimentsEnabled = _.result(this.Permissions, 'IsExperimentsEnabled');

    if (isExperimentsEnabled) {
      _.extendOwn(odataOptions.custom, {
        CampaignIsExperiment: {
          eq: (val) => {
            const operator = val ? 'gt' : 'le';

            return `ExperimentId ${operator} 0`;
          },
        },
      });
    }

    return odataOptions;
  }
}
